import {useAppSelector} from "../../store/hook";
import {Navigate, Outlet} from "react-router-dom";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import Loading from "../Loading";
import {EUserStatus} from "../../store/user/types";

const AuthRequire = () => {
    const {t} = useTranslation();
    const {isAuth, status} = useAppSelector((state) => state.userSlice);

    switch (status) {
        case EUserStatus.SUCCESS:
            if (isAuth) {
                return <Outlet/>;
            }
            break;
        case EUserStatus.IDLE:
            return null;
        case EUserStatus.LOADING:
            return <Loading/>;
        default:
            toast.error(t("toasts.auth.require"));
            return <Navigate to="/" replace state={{openAuth: true}}/>;
    }

    return null;
};

export default AuthRequire;
